import styled from '@emotion/styled';
import { isMobile, rem } from '@triumph/design-system';
import { BreakpointProps } from '@triumph/design-system/components/Modal/Modal.types';

export const Header = styled.div`
    display: flex;
    flex-direction: column;
    gap: ${rem(16)};
    justify-content: center;
    padding-bottom: ${rem(15)};
    border-bottom: ${rem(1)} solid
        ${({ theme }: any) => theme.colors.greyscale.gray15};
`;

export const DocumentInfo = styled.div<BreakpointProps>`
    display: flex;
    flex-direction: ${({ breakpoint }) =>
        isMobile(breakpoint) ? 'column' : 'row'};
    justify-content: center;
    align-items: center;
    gap: ${rem(16)};
    flex-wrap: wrap;
`;

export const FileNameDiv = styled.div`
    font-weight: 600;
    font-size: ${rem(14)};
    line-height: ${rem(24)};
    max-width: 100%;
    text-overflow: ellipsis;
    overflow: hidden;
    padding: 0 ${rem(16)};
`;

export const DocumentPreview = styled.div`
    border: ${rem(1)} solid ${({ theme }: any) => theme.colors.greyscale.gray15};
    width: 100%;
    & > img {
        width: 100%;
    }
`;
